import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';

const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/components/optionDictionaryComponentContrller/listOptionDictionary", params, successCallback,
			failCallback,
			exceptionCallback);
	}
}
export default api;
